'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-wrap: wrap;\n  min-width: 54%;\n  ', ';\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  min-width: 54%;\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0 0 8px 0;\n  display: block;\n  ', ';\n'], ['\n  margin: 0 0 8px 0;\n  display: block;\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 144px;\n  ', ';\n'], ['\n  width: 144px;\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n'], ['\n  list-style: none;\n  margin: 0;\n  padding: 0;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  margin-bottom: 8px;\n'], ['\n  margin-bottom: 8px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  &:hover{\n    color: ', '\n  }\n'], ['\n  &:hover{\n    color: ', '\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Social = require('./Social');

var _Social2 = _interopRequireDefault(_Social);

var _buoyText = require('buoy-text');

var _buoyList = require('buoy-list');

var _buoyTheme = require('buoy-theme');

var _buoyConfig = require('buoy-config');

var _dist = require('react-intl/dist');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div.withConfig({
  displayName: 'Links__Container',
  componentId: 'sc-1f4szja-0'
})(_templateObject, (0, _buoyTheme.responsive)("justify-content", "space-between", "space-between", "space-between", "space-between", "normal"));

var Header = (0, _styledComponents2.default)(_buoyText.Label).withConfig({
  displayName: 'Links__Header',
  componentId: 'sc-1f4szja-1'
})(_templateObject2, (0, _buoyTheme.responsive)("margin-bottom", "18px", "18px", "18px", "18px", "12px"));

var GroupContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Links__GroupContainer',
  componentId: 'sc-1f4szja-2'
})(_templateObject3, (0, _buoyTheme.responsive)("margin-bottom", "80px", "40px", "40px", "40px", "29px"));

var List = (0, _styledComponents2.default)(_buoyList.Ul).withConfig({
  displayName: 'Links__List',
  componentId: 'sc-1f4szja-3'
})(_templateObject4);

var ListItem = (0, _styledComponents2.default)(_buoyList.Li).withConfig({
  displayName: 'Links__ListItem',
  componentId: 'sc-1f4szja-4'
})(_templateObject5);

var StyledLink = (0, _styledComponents2.default)(_buoyText.Link).withConfig({
  displayName: 'Links__StyledLink',
  componentId: 'sc-1f4szja-5'
})(_templateObject6, _buoyTheme.colors["neutral"]);

var Group = function Group(_ref) {
  var heading = _ref.heading,
      links = _ref.links,
      baseUrl = _ref.baseUrl;
  return _react2.default.createElement(
    GroupContainer,
    null,
    _react2.default.createElement(
      Header,
      { color: 'neutral' },
      heading === "Company" ? _react2.default.createElement(_dist.FormattedMessage, { id: 'footer.header.company', defaultMessage: heading }) : heading === "Read more" ? _react2.default.createElement(_dist.FormattedMessage, {
        id: 'footer.header.readmore',
        defaultMessage: heading
      }) : heading === "Resources" ? _react2.default.createElement(_dist.FormattedMessage, {
        id: 'footer.header.resources',
        defaultMessage: heading
      }) : ""
    ),
    _react2.default.createElement(
      List,
      null,
      links.map(function (link) {
        return _react2.default.createElement(
          ListItem,
          { key: link.text },
          _react2.default.createElement(
            StyledLink,
            {
              color: 'neutralLightest',
              underline: false,
              href: (0, _buoyConfig.getAbsoluteUrl)(link.href, baseUrl)
            },
            link.text === "Team" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.team',
              defaultMessage: link.text
            }),
            link.text === "Writers" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.writers',
              defaultMessage: link.text
            }),
            link.text === "Careers" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.careers',
              defaultMessage: link.text
            }),
            link.text === "Press" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.press',
              defaultMessage: link.text
            }),
            link.text === "Businesses" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.employers',
              defaultMessage: link.text
            }),
            link.text === "Symptoms A-Z" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.symptomsaz',
              defaultMessage: link.text
            }),
            link.text === "Diagnoses A-Z" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.diagnosesaz',
              defaultMessage: link.text
            }),
            link.text === "Blog" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.blog',
              defaultMessage: link.text
            }),
            link.text === "Support" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.support',
              defaultMessage: link.text
            }),
            link.text === "Contact" && _react2.default.createElement(_dist.FormattedMessage, {
              id: 'footer.links.contact',
              defaultMessage: link.text
            })
          )
        );
      })
    )
  );
};

var Links = function Links(_ref2) {
  var content = _ref2.content,
      baseUrl = _ref2.baseUrl;
  return _react2.default.createElement(
    Container,
    null,
    content.map(function (_ref3) {
      var heading = _ref3.heading,
          links = _ref3.links;
      return _react2.default.createElement(Group, { key: heading, heading: heading, links: links, baseUrl: baseUrl });
    }),
    _react2.default.createElement(
      GroupContainer,
      null,
      _react2.default.createElement(
        Header,
        { color: 'neutral' },
        _react2.default.createElement(_dist.FormattedMessage, { id: 'footer.header.follow', defaultMessage: 'Follow Us' })
      ),
      _react2.default.createElement(_Social2.default, null)
    )
  );
};

exports.default = Links;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-footer/dist/components/Links.js
// module id = 409
// module chunks = 168707334958949